import * as React from "react";
import { Route } from 'react-router-dom';
import { ReportStatComponent } from './datagridReport';
import { RocketchatComponent } from "./rocketchat";
import { BiComponent } from "../bi/Bi";
import { BiProfileComponent } from "../bi/BiProfile";

const routes = [
    <Route exact path="/reportstat" component={ReportStatComponent} />,
    <Route exact path="/biNeed" component={BiComponent} />,
    <Route exact path="/biLoad" component={BiComponent} />,
    <Route exact path="/my-profile" component={BiProfileComponent} />,
    <Route exact path="/chat" component={RocketchatComponent} />,
];

export default routes;
